import { render } from "./EventList.vue?vue&type=template&id=566d2b72&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"

import "./EventList.vue?vue&type=style&index=0&id=566d2b72&scoped=true&lang=css"

import exportComponent from "E:\\VUE\\real-world\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-566d2b72"]])

export default __exports__